import { Dispatch, Action } from 'redux'
import { ToPreviousCycleButtonMapDispatchReturnType } from './types/ToPreviousCycleButtonMapDispatchReturnType'
import { createSubmitAction } from '../../../actionCreators/submit/Submit/createSubmitAction'
import { SUBMIT_MOVE_TASK_TO_CYCLE } from '../../../actions'

export const ToPreviousCycleButtonMapDispatch = (
  dispatch: Dispatch<Action>
): ToPreviousCycleButtonMapDispatchReturnType => {
  return {
    moveToPreviousCycle: (taskId) => {
      dispatch(
        createSubmitAction({
          type: SUBMIT_MOVE_TASK_TO_CYCLE,
          values: {
            cycle: 'previous',
            taskId,
          },
        })
      )
    },
  }
}
